const legacyPhoneNumberReplacements = [
  ['tel:+4915206829824', 'tel:+4917642887719'],
  ['+4915206829824', '+4917642887719'],
  ['+49 (0) 152 06829824', '+49 176 42887719'],
  ['+49 (0) 15206829824', '+49 176 42887719'],
  ['+49 (0)152 06829824', '+49 176 42887719'],
  ['+49 152 06829824', '+49 176 42887719'],
  ['+49 15206829824', '+49 176 42887719'],
] as const;

// Published editor projects are authoritative and can outlive code-level content defaults. This
// migration updates only the retired number in an old project revision. Once the project reaches
// the current revision, phone fields remain fully editor-controlled and are never forced again.
export const migrateLegacyPhoneNumber = (value: unknown): void => {
  if (Array.isArray(value)) {
    value.forEach(migrateLegacyPhoneNumber);
    return;
  }
  if (!value || typeof value !== 'object') return;

  const record = value as Record<string, unknown>;
  for (const [key, entry] of Object.entries(record)) {
    if (typeof entry === 'string') {
      record[key] = legacyPhoneNumberReplacements.reduce(
        (text, [legacyNumber, currentNumber]) => text.split(legacyNumber).join(currentNumber),
        entry,
      );
      continue;
    }
    migrateLegacyPhoneNumber(entry);
  }
};
